import Api from '@/lib/api/api';
import v5_Model from '@/models/v5/model';
import Radio from 'backbone.radio';
import _ from 'underscore';
var apiCh = Radio.channel('api');

var labels = {
    dmo : "Device Messages Out",
    dmi : "Device Messages In",
    dbo : "Bytes Out",
    dbi : "Bytes In",
    deployments: "Deployments",
    hx: "History"
};

var date_sort_asc = function (event1, event2) {
    var date1 = new Date(event1.ts);
    var date2 = new Date(event2.ts);
    // This is a comparison function that will result in dates being sorted in
    // ASCENDING order.
    if (date1 > date2) return 1;
    if (date1 < date2) return -1;
    return 0;
};

var BandwidthModel = v5_Model.extend({
    initialize: function() {
        if (this.type && this.type === 'device') {
            this.type = 'device_bandwidth';
        } else if ( this.type && this.type.indexOf('devicegroup') > -1 ) {
            this.type = 'devicegroup_bandwidth';
        }
    },
    data_store: [],
    data_store_sort: function(){
        this.data_store = _.chain(this.data_store).flatten().uniq().value();
    },
    url: function() {
        if ( this.type === 'device_bandwidth' ){
            return Api.urls.device_bandwidth({ id: this.id });
        } else {
            return Api.urls.device_group_bandwidth({ devicegroup_id: this.id });
        }
    },
    // d3_datum, returns api bandwidth data as d3 datum object, in order of keys specified
    // keys Array ['foo','bar','doh']
    // key hx is for future history object inclusion as part of returned data set
    // hx was built for device group history, not yet checked for integration with device history
    d3_datum: function(keys, dates){
        var return_data = [];

        keys.forEach(function(k, i) {
            return_data.push({ 'key': labels[k], 'values': []});
            // if ( k === 'hx') {
            //     return_data[i].bar = true;
            // }
        });

        var events = this.get('events');

        if ( events && events.length > 0){
            this.sort_events();
            var last_t;
            this.get('events').forEach(function(e){
                if (last_t && last_t === e.ts ) {
                    keys.forEach(function(k, i) {
                        if (k === 'hx') return;
                        var last = return_data[i].values.length - 1;
                        return_data[i].values[last].y = return_data[i].values[last].y + parseInt(e[k], 10);
                    });
                    last_t = e.ts;
                } else {
                    keys.forEach(function (k, i) {
                        if (k === 'hx') return;
                        return_data[i].values.push({ 'y': parseInt(e[k], 10), 'x': new Date(e.ts) });
                    });
                    last_t = e.ts;

                }
            });
            if (keys.includes('hx')){
                // rewrite, should figure out based on v5object.type
                var devicegroups = apiCh.request('development_devicegroup');
                var devicegroup = devicegroups.find({ id: this.id });
                var index = keys.indexOf('hx');
                devicegroup.history.each(function(h, i) {
                    return_data[index].values.push({'y': new Date(h.get('timestamp')), 'x': 1+i});
                });
            }
        } else {
            keys.forEach(function (k, i) {
                if (k === 'hx') return;
                var date_1 = new Date(dates.end_date);
                var date_2 = new Date(date_1.getFullYear()+'-'+(date_1.getMonth()+1)+'-'+(date_1.getDate()-1));

                return_data[i].values.push({ 'y': 0, 'x': new Date(date_2) });
                return_data[i].values.push({ 'y': 0, 'x': new Date(date_1) });
            });
        }
        return return_data;
    },
    sort_events: function() {
        this.get('events').sort(date_sort_asc);
    },
    // As of writing, API Supports returning 24 hours of information
    // at a time. Information could take as long as 30 minutes to appear
    // from it's creation
    fetch_day: function(date1, date2, interval) {
        var self = this;
        // we need to wipe out our current events, entirely, and replace with
        // new. Unless of course we decided to start parsing minutes into
        // larger chunks or something
        var current_events = [];
        var start_date = new Date(date1);
        var d1 = new Date( Date.UTC(start_date.getUTCFullYear(), start_date.getUTCMonth(), start_date.getUTCDate(), 0, 0, 0 ) );

        if (d1 == 'Invalid Date') {
            this.events = [];
            return;
        }
        var end_date = new Date(date2);
        var d2 = new Date( Date.UTC(end_date.getUTCFullYear(), end_date.getUTCMonth(), end_date.getUTCDate(), 11, 59, 59 ) );
        if (d2 == 'Invalid Date') {
            d2 = null;
        }

        // tweak time so as to include the whole day
        d2.setUTCHours(23);
        d2.setUTCMinutes(59);
        d2.setUTCSeconds(59);
        d2.setUTCMilliseconds(999);

        var options = {
            'filter[timestamp]':'gt:'+ d1.toISOString(),
            'interval': interval
        };
        if (d2) {
            options = {
                'filter[timestamp]':'gt:'+ d1.toISOString(),
                'filter[timestamp]': 'lt:' + d2.toISOString(), // eslint-disable-line
                'interval': interval
            };
        }

        return new Promise(function(resolve, reject) {
            self.fetch({ data: options })
                .then(function(){
                    current_events.forEach(function(e){ self.get('events').push(e); });
                    var my_ev = _.uniq(self.get('events'));
                    self.set('events', my_ev);
                    self.sort_events();
                })
                .then(
                    resolve, function(model, response) { reject(response); }
                );
        });

    },
    /*
        * fetch_more, adds on to the data in your graph
        * 
        * if check to see if it is in this.data_store && not 0,0
        *    all good
        * else
        *    fetch
        *
        * 2. 
        */
    fetch_more: function(e_or_t) {
        var self = this;
        var current_events = this.get('events');
        var data;

        if (e_or_t && e_or_t === 'later'){
            data = {
                'filter[timestamp]':'gt:'+ current_events[current_events.length -1].t
            };
        } else {
            data = {
                'filter[timestamp]':'lt:'+ this.get('events')[0].t,
            };
        }
        this.fetch({
            data: data
        }).then(function(){
            current_events.forEach(function(e){ self.get('events').push(e); });
            var my_ev = _.uniq(self.get('events'));
            self.set('events', my_ev);
            self.sort_events();

            if ( self.get('events') && self.get('events').length >= 4320 ) {
                if (e_or_t && e_or_t === 'later'){
                    self.get('events').splice(0, 1439);
                } else {
                    self.get('events').splice(-1440, 1440);
                }
            }
            self.trigger('change');
        });
    },
});

export default BandwidthModel;

